import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AddCategoryAction, CategoryAction } from "../../redux/Action/ProfileAction";
import { FormattedMessage } from "react-intl";

const AddCategory = () => {
    const dispatch = useDispatch<any>()
    const categoryData = useSelector((state: any) => state.CategoryState);
    const [checkedItems, setCheckedItems] = useState<{ [key: string]: boolean }>({});

    const isAnyChecked = Object.values(checkedItems).some((isChecked) => isChecked);


    const handleCheckboxChange = (id: string) => {
        setCheckedItems((prev) => ({ ...prev, [id]: !prev[id] }))
    };

    const handleAddCategory = async () => {
        const selectedIds = Object.keys(checkedItems).filter((id) => checkedItems[id]);
        await dispatch(AddCategoryAction({ categoriess: selectedIds }))
        await dispatch(CategoryAction({}));

    };

    const handleDeleteCategory = () => {
        setCheckedItems({});
    };


    return (
        <>
            <div className="modal modelStyle fade" id="AddCategory" tabIndex={-1} aria-labelledby="exampleModalLabel3"

                data-bs-backdrop="static" aria-hidden="true" data-bs-keyboard="false">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content ">


                        <div className="modal-header">

                            <h5 className="modal-title"><FormattedMessage id="add_category" /></h5>
                            {categoryData?.data?.data?.length == 0 && <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>}
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className='category'>
                                    <ul>
                                        {
                                            categoryData?.data?.data?.length > 0 && categoryData?.data?.data?.map((item: any, index: any) => {

                                                return (
                                                    <>
                                                        <li key={index}>
                                                            <input type="checkbox" className="btn-check" id={`btn-check${item?.id}`} autoComplete="off"
                                                                onChange={() => handleCheckboxChange(item?.id)}
                                                                checked={checkedItems[item?.id] || false}
                                                            />
                                                            <label htmlFor={`btn-check${item?.id}`}>
                                                                <figure className="placeholder-glow"><img onError={(e: any) => e.target.src = "images/fely-beauty.jpg"}
                                                                    src={item?.image_details?.file_path} /><span className="icon-check"></span></figure>
                                                                <p>{item?.name}</p>
                                                            </label>
                                                        </li>
                                                    </>
                                                )
                                            })
                                        }



                                    </ul>
                                    {
                                        categoryData?.data?.data?.length == 0 ? (
                                            <>
                                                <div className='d-flex align-items-center'>

                                                    <h4> <FormattedMessage id="categories_not_found"/> </h4>

                                                </div>

                                            </>
                                        ) : (
                                            <div className='d-flex align-items-center'>
                                                <button type="button" className="btn btnOUtlinegray me-3" data-bs-dismiss="modal" onClick={handleDeleteCategory}><FormattedMessage id="cancel" /></button>
                                                <button type="button" className="btn btn-fill w-100" data-bs-dismiss="modal" disabled={!isAnyChecked} onClick={handleAddCategory}><FormattedMessage id="add_now" /></button>
                                            </div>
                                        )

                                    }
                                </div>


                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default React.memo(AddCategory)